module.exports = __webpack_public_path__ + "static/media/BlackKingBar.3b8f9ebd.png";